require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[34],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(320);


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Link = _interopRequireDefault(__webpack_require__(321));

exports["default"] = _Link["default"];
exports.Link = _Link["default"];

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

var _utils = __webpack_require__(4);

var _Link = _interopRequireDefault(__webpack_require__(322));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var linkClassName = _Link["default"].linkClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Link = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Link, _Component);

  function Link() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_interactive", function () {
      var _this$props = _this.props,
          href = _this$props.href,
          onClick = _this$props.onClick,
          tabIndex = _this$props.tabIndex,
          disabled = _this$props.disabled;
      return (href != null || onClick || tabIndex > -1) && !disabled;
    });
    return _this;
  }

  var _proto = Link.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        href = _this$props2.href,
        children = _this$props2.children,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        tabIndex = _this$props2.tabIndex,
        disabled = _this$props2.disabled,
        bgDark = _this$props2.bgDark,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["href", "children", "onClick", "className", "style", "tabIndex", "disabled", "bgDark"]);
    var classNames = (0, _utils.classnames)("" + linkClassName, {
      bgDark: bgDark
    });
    var cProps = {
      href: href || '#',
      className: classNames + " " + className,
      style: style,
      disabled: disabled,
      onClick: disabled ? function () {
        return false;
      } : onClick
    };

    if (tabIndex > -1) {
      cProps.tabIndex = tabIndex;
    } else {
      cProps.tabIndex = this._interactive() ? 0 : -1;
    }

    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Link, (0, _extends2["default"])({}, others, cProps), children);
  };

  return Link;
}(_react.Component);

exports["default"] = Link;
(0, _defineProperty2["default"])(Link, "propTypes", {
  href: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  hover: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
  active: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  small: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
  shouldForceTabIndex: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
  disabled: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  bgDark: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Link, "defaultProps", {
  className: '',
  style: {},
  tabIndex: -1,
  disabled: false,
  bgDark: false
});

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(323);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-carbon-link.is-bgDark.bx--link{color:#78a9ff}.ba-common-carbon-link.is-bgDark.bx--link:hover{color:#78a9ff}.ba-common-carbon-link.is-bgDark.bx--link:active{color:#fff}\n", ""]);

// exports
exports.locals = {
	"linkClassName": "\"ba-common-carbon-link\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[319,0]]]);
});